<template>
    <header>
        <div class="d-flex justify-content-between align-items-center flex-wrap py-2">
            <div class="col-12 col-lg-2 text-center mb-4 mb-lg-0">
                <a href="https://www.bresciamobilita.it/">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}.svg`)" class="tenant-logo">
                </a>
            </div>
            <div class="col-12 col-lg-8 d-flex justify-content-between align-items-center flex-wrap services mb-4 mb-lg-0">
                <a href="https://www.bresciamobilita.it/map#/mode=busRoutes/routes" class="text-center text-decoration-none text-third">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}/trasporto.png`)">
                    <h6 class="mt-2">
                        TRASPORTO PUBBLICO
                    </h6>
                </a>
                <a href="https://www.bresciamobilita.it/map#/mode=busRoutes/poitypes=ztlarea,ztlentrance" class="text-center text-decoration-none text-third">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}/ztl.png`)">
                    <h6 class="mt-2">
                        ZTL
                    </h6>
                </a>
                <a href="https://www.bresciamobilita.it/map#/mode=busRoutes/poitypes=parking" class="text-center text-decoration-none text-third">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}/parcheggio.png`)">
                    <h6 class="mt-2">
                        PARCHEGGI
                    </h6>
                </a>
                <a href="https://www.bresciamobilita.it/map#/mode=busRoutes/poitypes=bicimia" class="text-center text-decoration-none text-third">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}/bici.png`)">
                    <h6 class="mt-2">
                        BICI MIA
                    </h6>
                </a>
                <a href="https://www.bresciamobilita.it/map#/mode=calculatePath" class="text-center text-decoration-none text-third">
                    <img :src="require(`@/assets/img/tenants/${omsApiKey}/percorso.png`)">
                    <h6 class="mt-2">
                        CALCOLA PERCORSO
                    </h6>
                </a>
            </div>
            <div class="col-12 col-lg-2 d-flex justify-content-center">
                <LanguagesSelect class="select-auth"/>
            </div>
        </div>
        <nav class="d-flex justify-content-between align-items-center flex-wrap p-2 bg-fourth">
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-secondary">
                <strong>
                    HOME
                </strong>
            </a>
            <div class="d-flex align-items-center">
                <img src="https://www.bresciamobilita.it/assets/img/icon-blue.png">
                <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third ms-2">
                    <strong>
                        AUTOBUS
                    </strong>
                </a>
            </div>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    METRO
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    SHARING
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    PARKING
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    ZTL
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    ALTRI
                    SERVIZI
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    NEWS
                </strong>
            </a>
            <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-third">
                <strong>
                    PUNTI
                    DI CONTATTO
                </strong>
            </a>
            <div class="d-flex align-items-center">
                <img src="https://www.bresciamobilita.it/assets/img/icon-green.png">
                <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-success ms-2">
                    FORNITORI
                </a>
            </div>
            <a href="https://www.bresciamobilita.it/fornitori/cercalavoro" class="text-decoration-none text-success ms-2">
                CERCA LAVORO
            </a>
            <div class="d-flex align-items-center">
                <img src="https://www.bresciamobilita.it/assets/img/icon-orange.png">
                <a href="https://www.bresciamobilita.it/" class="text-decoration-none text-second ms-2">
                    IL GRUPPO
                </a>
            </div>
        </nav>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'HeaderComp',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapGetters(['omsApiKey'])
    }
}
</script>

<style lang="scss" scoped>
    .tenant-logo {
        width: 50%;
    }

    @media screen and (max-width: 992px) {
        .tenant-logo {
            width: 15%;
        }

        nav {
            display: none !important;
        }
    }

    @media screen and (max-width: 768px) {
        .tenant-logo {
            width: 25%;
        }

        .services {
            display: none !important;
        }
    }
</style>